import { Popconfirm, message } from 'antd'
import { RightSquareOutlined } from '@ant-design/icons'
import { mainStore } from 'enasops/stores'
import { $api } from 'src/plugins'

export default {
  SyncBtn (ListTableContext: any, props: any) {
    const handleSync = () => {
      const { selectedRow } = ListTableContext
      const payload = {
        Keyword: selectedRow.ID,
        OrgId: mainStore.headers.OrgId,
        Parameter1: selectedRow.SYNC_PARAM
      }
      message.loading('执行中...')
      $api['app/getDataByPost'](
        payload,
        { url: selectedRow.INTERFACE_ADDRESS }
      ).then((res: any) => {
        res ? message.success('执行成功') : message.error('执行失败')
      })
    }

    const { LABEL } = props.config
    return (
      <Popconfirm title='是否确认执行？' onConfirm={handleSync}>
        <span title={LABEL}>
          <RightSquareOutlined className='fz-16' />
          <span className='pd-l4'>{LABEL}</span>
        </span>
      </Popconfirm>
    )
  }
}